document.addEventListener('DOMContentLoaded', function () {
  // Make first FAQ item open by default
  const firstFaqItem = document.querySelector('.faq-item');
  if (firstFaqItem) {
    firstFaqItem.classList.add('is-open');
  }

  document.querySelectorAll('.faq-question').forEach(function (question) {
    question.addEventListener('click', function () {
      const item = question.closest('.faq-item');
      if (item) {
        item.classList.toggle('is-open');
      }
    });
  });
});
